import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "staleNotice", "previewSubmitter", "state"]
  static values = { url: String }

  preview() {
    this.loadPreview()
  }

  refresh() {
    if (!this.hasStateTarget || !this.hasPreviewSubmitterTarget) {
      return
    }

    this.loadPreview()
  }

  loadPreview() {
    if (!this.hasPreviewSubmitterTarget) {
      return
    }

    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }

    if (this.hasStaleNoticeTarget) {
      this.staleNoticeTarget.classList.remove("hidden")
    }

    this.element.src = this.previewUrl()
  }

  previewUrl() {
    const url = new URL(this.urlValue, window.location.origin)
    const form = this.previewSubmitterTarget.form

    if (!form) {
      return url.toString()
    }

    const params = new URLSearchParams(new FormData(form))
    params.delete("authenticity_token")
    url.search = params.toString()

    return url.toString()
  }
}